import UploadField from './upload-field'

export default UploadField


// WEBPACK FOOTER //
// ./src/components/fields/upload-field/index.js